// import React, { useState } from 'react';
// import PropTypes from 'prop-types'
// import { Button, Form,Container, Spinner } from 'react-bootstrap';
// import MaskedFormControl from 'react-bootstrap-maskedinput'
// import { useNavigate , useParams} from 'react-router-dom';
// import './../CSS/form.css';
// import Row from "react-bootstrap/Row";
// import Col from "react-bootstrap/Col";
// import moment from 'moment'

// import axios from 'axios';
// import Notification from './../../Components/assets/Modals/notification'
// import {REGISTER_STUDENT, REGISTER_PLUS3_STUDENT} from './../../url/index'
// import NotifyError from './../../Components/assets/Modals/errorModal'
// const Register = props => {
  
//   const navigate = useNavigate();
// //  const navigateToHome = () => {
// //   navigate('/');
// //  }
//  const handleClear = () => {
//   setEachEntry(initialInputState);
//  }

//  const {id} = useParams ();

//  const artsHonourseList = [
//   {Id:0,Name:'Select'},
//   {Id:1,Name:'Education'},
//   {Id:2,Name:'Odia'},
//   {Id:3,Name:'Sociology'},
//   {Id:4,Name:'Political Science'},
//  ]

//  const commerceHonourseList = [
//   {Id:0,Name:'Select'},
//   {Id:5,Name:'Commerce (Hons.)'},
 
//  ]

//  const scienceHonourseList = [
//   {Id:0,Name:'Select'},
//   {Id:6,Name:'Physics'},
//   {Id:7,Name:'Chemistry'},
//   {Id:8,Name:'Mathematics'},
//   {Id:9,Name:'Botany'},
//   {Id:10,Name:'Zoology'},
//   {Id:11,Name:'Geology'},
//   {Id:12,Name:'Computer Science'}
//  ]

//  const prof_course_List = [
//   {Id:0,Name:'Select'},
//   {Id:3,Name:'MBA'},
//   {Id:4,Name:'MCA'},
//   {Id:5,Name:'BBA'},
//   {Id:6,Name:'BCA'},
//   {Id:7,Name:'MFC'},
//   {Id:8,Name:'MSW'},
//   {Id:9,Name:'B.LIB'},
 
 
// ]
 
//  const [validated, setValidated] = useState(false);
//  const initialInputState = { 
//    FirstName: "",
//     MiddleName:"",
//     LastName:"",
//     PersonalEmail:"",
//     PersonalCellNumber:'',
//     ParentCellNumber:'',
//     AdhaarNumber:'',
//     PIN:'',
//     DOB: '',
//     dobError:'',
//     Gender:'',
//     Stream:'',
//     Category:'',
//     Type:'',
//     Address:'',
//     FatherName:'',
//      MotherName:'',
//      Religion:'',
//      BloodGroup:'',
//      LastQualifyName:'',
//      LastQualifyBoardName:'',
//      LastQualifyRollNumber:'',
//      LastQualifyMarks:'',
//      ReferredBy:'',
//      SchoolInfo:'',
//      IsSuccess:false,
//      message:'',
//      isLoading:false,
//      title:'',
//      isHideErrorModal:true,
//      errMessage:'',
//      validationError:null,
//      errortitle:'',
//      typeError:'',
//      categoryError:'',
//      streamError:'',
//      courseError:'',
//      MR_Number:'',
//      Amount:'',
//      Honours:'',
//      isHonoursDisabled:true,
//      honourseList:[],
//      honoursError:'',
//      Course:null,
//      msgList:[]
  
//   };
//   const [eachEntry, setEachEntry] = useState(initialInputState);
//   const {FirstName, LastName, MiddleName,
//      PersonalEmail, PersonalCellNumber,ParentCellNumber,
//      AdhaarNumber, PIN, DOB, dobError, Gender, Stream,Category,Type, Address,
//      FatherName, MotherName,Religion,BloodGroup,
//      LastQualifyName,LastQualifyBoardName, LastQualifyRollNumber, LastQualifyMarks,
//      ReferredBy, SchoolInfo,IsSuccess, message, isLoading, title, isHideErrorModal, msgList,
//       errMessage, validationError, errortitle, typeError, categoryError, streamError, courseError, MR_Number, Amount, isHonoursDisabled, Honours, honoursError} = eachEntry;
//       let course = ''
//       if(id == 1)
//       {
//         course = "+2 Arts/Science/Commerce "
//       }
//       else if(id ==2)
//       {
//         course = "+3 Arts/Science/Commerce "
//       }
//       else if(id == 3)
//       {
//         course = "MBA/MCA/BBA/BCA/MFC/MSW/B.LIB "
//       }

     

//   const handleInputChange = e => {
//       setEachEntry({ ...eachEntry, [e.target.name]: e.target.value });
//   };

//   const handleNumberChange = e => {
//       let num = e.target.value.replace(/\D/g, "");
//       setEachEntry({ ...eachEntry, [e.target.name]: num });
//   };
 
// const handleKeyDown = (e) =>{
//   if (e.key === " ") {
//     e.preventDefault();
//   }
// }



// const handleDateChange = (e) =>{
// setEachEntry({ ...eachEntry, [e.target.name]: e.target.value, dobError: "" });
// }

// const dateValidation = () => {

// const dateArray = DOB.split("/");

// const day = parseInt(dateArray[0]); 
// const month = parseInt(dateArray[1]); 
// const year = parseInt(dateArray[2]); 
// const currentYear = new Date().getFullYear() 



// if(day > 31)
// {
//   setEachEntry({ ...eachEntry, dobError: "Enter a valid day" });
//   return false
// }
// else if(month > 12)
// {
//   setEachEntry({ ...eachEntry, dobError: "Enter a valid month" });
//   return false
// }
// else if(currentYear < year || (currentYear - year) < 12)
// {
//   setEachEntry({ ...eachEntry, dobError: "Enter a valid year" });
//   return false
// }

// else{
//   var mydate = new Date(dateArray[0], dateArray[1] - 1, dateArray[2]); 

//   setEachEntry({ ...eachEntry, DOB: mydate, dobError: "" });
//   return true;
// }

// }

// const handleRadioChange = (e) => {
 
//   setEachEntry({ ...eachEntry, [e.target.name]: e.target.id });
// }

// const handleDDLChange = (e) =>{
//   const {name,value,id} = e.target;
  
//   if(name === 'Stream')
//   {
//     let list = []
//     if(value.toLowerCase().includes("arts"))
//     {
//       list = artsHonourseList
//     }
//    else if(value.toLowerCase().includes("commerce"))
//     {
//        list = commerceHonourseList
//     }

//     else if(value.toLowerCase().includes("science"))
//     {
//        list = scienceHonourseList
//     }
//     setEachEntry({
//        ...eachEntry,
//         isHonoursDisabled: false,
//          honourseList: list,
//          [name]: value,
//          [[id]]:'',
//          Honours: value.toLowerCase().includes("commerce") ? '5':'0'
//          });
//   }
//   else{
//     setEachEntry({ ...eachEntry, [name]: value, [[id]]:'' });
//   }
// }

// const handleCourseDDLChange = (e) => {
//   const {name,value,id} = e.target;
//   setEachEntry({ ...eachEntry, [e.target.name]: value,  [[id]]:'' });
// }

// const handleMarkChange = (e) => {
//   let num = e.target.value
//   if(num.includes("."))
//   {
//     const dateArray = num.split(".");
//     if(dateArray.length > 0)
//     {
      
//       const temp2 = parseInt(dateArray[1]);
//       if(temp2 < 100) 
//       setEachEntry({ ...eachEntry, [e.target.name]: num });
//     }
   
//   }
//   else{
//     if(num < 100)
//     setEachEntry({ ...eachEntry, [e.target.name]: num });
//   }
 
 
// }

// const handleSelectValidation = (e) => {
// const {Type, Stream, Category, Honours, Course} = eachEntry


// if(id != 3 && (Stream == null || Stream.length == 0))
// {
//   setEachEntry({ ...eachEntry, streamError: "Select Stream" });
//   return  false
//   }

//   if(id == 2 && (Honours == null || Honours.length == 0 || Honours == "0"))
//     {
//       setEachEntry({ ...eachEntry, honoursError: "Select Honours" });
//       return  false
//       }
      
      
//   if(Category == null || Category.length == 0)
//   {
//     setEachEntry({ ...eachEntry, categoryError: "Select Category" });
//     return  false
//     }
//  if(Type == null || Type.length == 0)
//   {
//   setEachEntry({ ...eachEntry, typeError: "Select Type" });
//   return  false
//   }

//   if(id == 3 && Course == null)
//   {
//     setEachEntry({ ...eachEntry, courseError: "Select Course" });
//   return  false
//   }

//  return true;

// }

//  const handleSubmit = async (event) => {
  
//    const form = event.currentTarget;
//    event.preventDefault();
//    event.stopPropagation();
//    if (form.checkValidity() === true && dateValidation() && handleSelectValidation()) {
//     SaveStudent();
//     }
//     else{
//       window.scrollTo(0, 0);
//     }
//      setValidated(true);
    
//  };

//  const SaveStudent = async () => {
//   let response = null;
// var dob = moment.utc(eachEntry.DOB, "DD-MM-YYYY");

//   try {
//    // let formData = { ...eachEntry,DOB:dob, PIN: parseInt(eachEntry.PIN), LastQualifyMarks: parseFloat(eachEntry.LastQualifyMarks), Amount: parseInt(eachEntry.Amount)}
//   let payload = {
//     FirstName: eachEntry.FirstName,
//     MiddleName:eachEntry.MiddleName,
//     LastName:eachEntry.LastName,
//     PersonalEmail:eachEntry.PersonalEmail,
//     PersonalCellNumber:eachEntry.PersonalCellNumber,
//     ParentCellNumber:eachEntry.ParentCellNumber,
//     AdhaarNumber:eachEntry.AdhaarNumber,
//     PIN: parseInt(eachEntry.PIN),
//     DOB: dob,
//     Gender:eachEntry.Gender,
//     Stream:eachEntry.Stream,
//     Category:eachEntry.Category,
//     AccomodationType:eachEntry.Type,
//     Address:eachEntry.Address,
//     FatherName:eachEntry.FatherName,
//      MotherName:eachEntry.MotherName,
//      Religion:eachEntry.Religion,
//      BloodGroup:eachEntry.BloodGroup,
//      LastQualifyName:eachEntry.LastQualifyName,
//      LastQualifyBoardName:eachEntry.LastQualifyBoardName,
//      LastQualifyRollNumber:eachEntry.LastQualifyRollNumber,
//      LastQualifyMarks: parseFloat(eachEntry.LastQualifyMarks),
//      ReferredBy:eachEntry.ReferredBy,
//      SchoolInfo:eachEntry.SchoolInfo,
//      MR_Number:eachEntry.MR_Number,
//      Amount: parseInt(eachEntry.Amount),
//      CourseId: id == 3 ? parseInt(eachEntry.Course): parseInt(id),
//      Honours: parseInt(eachEntry.Honours),
     
//   }

//  setEachEntry({ ...eachEntry, isLoading: true});
//  response = await axios.post(REGISTER_STUDENT, payload);

//  if(response.status === 201)
//  {
//   let course_name = ''
//   if(payload.CourseId > 2)
//   {
//     course_name = prof_course_List.find(x => x.Id == payload.CourseId).Name
//   }
//   else if(payload.CourseId == 1){
//     course_name = "+2 " + payload.Stream
//   }

//   else if(payload.CourseId == 2){
//     course_name = "+3 " + payload.Stream
//   }

//    //let msg = "You have successfully registered for " + course_name + ". Your registration number is " + response.data.Payload + ". Thank you for showing interest for CTG."
//    let temp = []
//    temp.push("You have successfully registered for " + course_name)
//    temp.push("Your registration number is " + response.data.Payload)
//    temp.push("The final admission will take place after submitting the necessary documents and fee at Office")

//    setEachEntry({ ...eachEntry, isLoading: false, IsSuccess: true, title:"Success", msgList: temp});
// }

// else{
//   setEachEntry({ ...eachEntry, isLoading: false, IsSuccess: true, title:"Error occurred!", message:"Error Occurred...!"});

// }

//   }
//    catch (error) {
   
//     if(error.response.data)
//     {
//        if(error.response.status === 400)
//      {
//         if(error.response.data.Error.ValidationErrors != null)
//         {
//           const validationError =  error.response.data.Error.ValidationErrors
//           setEachEntry({ ...eachEntry, isLoading: false, isHideErrorModal: false, errortitle:"Validation Error occurred!", errMessage: error.response.data.Error.Message, validationError: validationError});
//          // setEachEntry({ ...eachEntry, isLoading: false, IsSuccess: true,title:"Error occurred!", message: error.response.data.Error.Message});
//         }
//         else{
//           setEachEntry({ ...eachEntry, isLoading: false, isHideErrorModal: false,errortitle:"Error occurred!", errMessage: error.response.data.Error.Message });
//         }
     
//      }
//      else{
//       setEachEntry({ ...eachEntry, isLoading: false, isHideErrorModal: false,errortitle:"Error occurred!", errMessage: "Please contact support." });
//      }
//     }
//     else
//     setEachEntry({ ...eachEntry, isLoading: false, isHideErrorModal: false,errortitle:"Error occurred!", errMessage: "Please contact support." });
// }
// }
// //"The JSON value could not be converted to System.Nullable`1[System.Int64]. Path: $.AdhaarNumber | LineNumber: 0 | BytePositionInLine: 197."
// const handleClose = () => {
//   setEachEntry({ ...eachEntry, IsSuccess: false, message : '', msgList : []});
//   window.location.reload();
//   window.scrollTo(0, 0);
  
// }
// const handleCloseErrorModal = () => {
//   setEachEntry({ ...eachEntry, isHideErrorModal: true, message : '', msgList : [], errMessage : '',errortitle:'', validationError: null});
// }

//   return (
//     <div className='App'>
//     <div className='container'>
  
//       <div className='heading'>
//                <label>CTG Registration cum Admission Form</label>
//                <br/>
//                <label>{"for " + course}</label>
//                 </div>
                
                
//       <Form className='details' noValidate validated={validated} onSubmit={handleSubmit}>
//        {/* <Container> 
//       <Row className="mb-2"> */}
//   <Form.Group   className="mb-2" controlId="validationCustom01">
//     <Form.Label ><span className="required">First Name</span></Form.Label>
//     <Form.Control 
//     size='sm' 
//     type="input" 
//     placeholder="Enter first name" 
//     required = {true}
//     onChange={handleInputChange}
//     value={FirstName}
//     name="FirstName"
//     onKeyDown={handleKeyDown}
//     />
//     <Form.Control.Feedback type="invalid">
//               Please enter  first name.
//             </Form.Control.Feedback>
//   </Form.Group>

//   <Form.Group  className="mb-2" controlId="formBasicPassword">
//     <Form.Label>Middle Name</Form.Label>
//     <Form.Control
//      size='sm'
//       type="input"
//        placeholder="Enter middle name"
//        onChange={handleInputChange}
//        value={MiddleName}
//        name="MiddleName"
//        onKeyDown={handleKeyDown}
//        />
//   </Form.Group>

//   <Form.Group  className="mb-2" controlId="formBasicPassword">
//     <Form.Label><span className="required">Last Name</span></Form.Label>
//     <Form.Control 
//     size='sm'
//      type="input"
//       placeholder="Enter last name"
//        required
//        onChange={handleInputChange}
//        value={LastName}
//        name="LastName"
//        onKeyDown={handleKeyDown}
//        />
//     <Form.Control.Feedback type="invalid">
//               Please enter  last name.
//             </Form.Control.Feedback>
//   </Form.Group>
 
//   <Form.Group   className="mb-2">
//     <Form.Label><span className="required">Contact number</span></Form.Label>
//     <Form.Control 
//     size='sm' 
//     type="tel"
//     maxLength="10"
//     minLength="10"
//      pattern="[0-9]*"
//       required
//       onChange={handleNumberChange}
//       value={PersonalCellNumber}
//       name="PersonalCellNumber"
//       />
//     <Form.Control.Feedback type="invalid">
//               Please enter  contact number.
//             </Form.Control.Feedback>
//   </Form.Group>
//   <Form.Group   className="mb-2" controlId="formBasicEmail">
//     <Form.Label>Email</Form.Label>
//     <Form.Control
//      size='sm'
//       type="email"
//        placeholder="Enter email address"
//        onChange={handleInputChange}
//        value={PersonalEmail}
//        name="PersonalEmail"
//        />
//     <Form.Control.Feedback type="invalid">
//     Plesae enter valid email.
//             </Form.Control.Feedback>
//   </Form.Group>
//   {/* </Row> */}

//    {/* <Row className="mb-2"> */}
//   <Form.Group  className="mb-2">
  
//   <Form.Label><span className="required">Date Of Birth</span></Form.Label>
//         <MaskedFormControl size='sm'
//          type='text' 
//           mask='11/11/1111'
//           required
//           onChange={handleDateChange}
//           value = {DOB}
//           name="DOB"
//           />
//         <Form.Control.Feedback type="invalid">
//               Please enter  DOB.
//             </Form.Control.Feedback>
//             <Form.Text style={{color:"red"}}>
//             {dobError}
//        </Form.Text>
//       </Form.Group>
  
//   <Form.Group className="mb-2">
//   <Form.Label><span className="required">Gender</span></Form.Label>
//   {['radio'].map((type) => (
//     <div key={`inline-${type}`} className="mb-2">
//       <Form.Check
//       size='sm'
//         inline
//         label="Male"
//         name="Gender"
//         type={type}
//         value = {Gender}
//         onChange = {handleRadioChange}
//         id= 'Male'
//         required
//       />
//       <Form.Check
//       size='sm'
//         inline
//         label="Female"
//         name="Gender"
//         type={type}
//         value = {Gender}
//         onChange = {handleRadioChange}
//         id= 'Female'
//         required
//       />
//        <Form.Check
//         size='sm'
//         inline
//         label="Other"
//         type={type}
//          name="Gender"
//          value = {Gender}
//          onChange = {handleRadioChange}
//          id= 'Other'
//          required
//       /> 
      
//     </div>
    
//   ))}
//    <Form.Control.Feedback type="invalid">
//      Please select  gender.
//    </Form.Control.Feedback>
//   </Form.Group>
//   {(id == 3)
  
//   ?  <Form.Group  className="mb-2">
  
//   <Form.Label><span className="required">Select Course</span></Form.Label>
//   <Form.Select size='sm' aria-label="Default select example" 
//    name="Course"
//    id = 'courseError'
//    defaultValue={'DEFAULT'}
//    onChange = {handleCourseDDLChange}
//   required
//   >

// {prof_course_List.map((x,y) => <option value= {x.Id} key={y}>{x.Name}</option>)}

//    {/* <option value="DEFAULT" disabled>Select</option>
   
//   <option value= {3}>MBA</option>
//   <option value={4}>MCA</option>
//   <option value={5}>BBA</option>
//   <option value={6}>BCA</option>
//   <option value={7}>MFC</option>
//   <option value={8}>MSW</option>
//   <option value={9}>B.LIB</option>  */}
// </Form.Select>
// <Form.Control.Feedback type="invalid">
//               Please select  Course.
//             </Form.Control.Feedback>
//             <Form.Text style={{color:"red"}}>
//             {courseError}
//        </Form.Text>
// </Form.Group>
  
//   :

//   <Form.Group  className="mb-2">
  
//   <Form.Label><span className="required">Select Stream</span></Form.Label>
//   <Form.Select size='sm' aria-label="Default select example" 
//    name="Stream"
//    id = 'streamError'
//    defaultValue={'DEFAULT'}
//    onChange = {handleDDLChange}
//   required
//   >
//   <option value="DEFAULT" disabled>Select</option>
//    {/* <option value="" disabled selected>Select</option>  */}
//   <option value= {"Arts"}>Arts</option>
//   <option value={"Science"}>Science</option>
//   <option value={"Commerce"}>Commerce</option>
// </Form.Select>
// <Form.Control.Feedback type="invalid">
//               Please select  stream.
//             </Form.Control.Feedback>
//             <Form.Text style={{color:"red"}}>
//             {streamError}
//        </Form.Text>
// </Form.Group>
//   }
 

// {(id == 2) && 

// <Form.Group   className="mb-2">
  
//   <Form.Label><span className="required">Select honours</span></Form.Label>
//   <Form.Select disabled = {isHonoursDisabled} size='sm' aria-label="Default select example" 
//    name="Honours"
//    value = {Honours}
//    id = 'honoursError'
//    defaultValue={'Select'}
//    onChange = {handleDDLChange}
//    required
//   >
//       {eachEntry.honourseList.map((x,y) => <option value= {x.Id} key={y}>{x.Name}</option>)}
// </Form.Select>
// <Form.Control.Feedback type="invalid">
//               Please select  honours.
//             </Form.Control.Feedback>
//             <Form.Text style={{color:"red"}}>
//             {honoursError}
//        </Form.Text>
// </Form.Group>
// }


// <Form.Group  className="mb-2">
// <Form.Label><span className="required">Select Category</span></Form.Label>
// <Form.Select required size='sm' aria-label="Default select example"
//  name="Category"
//  id = 'categoryError'
//  defaultValue={'DEFAULT'}
//  onChange = {handleDDLChange}
 
// >
// <option value="DEFAULT" disabled>Select</option>
//   <option value={"ST"}>ST</option>
//   <option value={"SC"}>SC</option>
//   <option value={"OBC"}>OBC</option>
//   <option value={"SEBC"}>SEBC</option>
//   <option value={"General"}>General</option>
// </Form.Select>
// <Form.Control.Feedback type="invalid">
//      Please select  category.
//    </Form.Control.Feedback>
//    <Form.Text style={{color:"red"}}>
//             {categoryError}
//        </Form.Text>
// </Form.Group>

// <Form.Group required  className="mb-2">
  
//   <Form.Label><span className="required">Select Type</span></Form.Label>
//   <Form.Select required size='sm' aria-label="Default select example" 
//    name="Type"
//    id = 'typeError'
//    defaultValue={'DEFAULT'}
//    onChange = {handleDDLChange}
//   >
//   <option value="DEFAULT" disabled>Select</option>
//    {/* <option value="" disabled selected>Select</option>  */}
//   <option value= {"Day Boarding"}>Day Boarding</option>
//   <option value= {"Day Scholar"}>Day Scholar</option>
//   <option value={"Residential"}>Residential</option>
// </Form.Select>
// <Form.Control.Feedback type="invalid">
//               Please select  Type.
//             </Form.Control.Feedback>
//              <Form.Text style={{color:"red"}}>
//             {typeError}
//        </Form.Text>
// </Form.Group>

// <Form.Group className="mb-2" controlId="formBasicPassword">
//     <Form.Label>MR Number</Form.Label>
//     <Form.Control size='sm'
//      type="input" 
//      placeholder="Enter money receipt no."
     
//       value={MR_Number}
//       name = "MR_Number"
//       onChange={handleInputChange}
//       />
    
//   </Form.Group>

//   <Form.Group  xs={2} className="mb-2" >
//   <Form.Label>Amount Paid</Form.Label>
//     <Form.Control  size='sm' 
//    type="tel"
//    maxLength="5"
//    minLength="3"
//     pattern="[0-9]*"
//      onChange={handleNumberChange}
//      value={Amount}
//      name="Amount"
//       />
    
//   </Form.Group>
  
//   {/* </Row>
//   <Row className="mb-2"> */}
// <Form.Group className="mb-2" controlId="formBasicPassword" required>
//     <Form.Label><span className="required">Father's Name</span></Form.Label>
//     <Form.Control size='sm'
//      type="input" 
//      placeholder="Enter father name"
//       required
//       value={FatherName}
//       name = "FatherName"
//       onChange={handleInputChange}
//       />
//     <Form.Control.Feedback type="invalid">
//      Please enter  father's name.
//    </Form.Control.Feedback>
//   </Form.Group>

//   <Form.Group  className="mb-2" controlId="formBasicPassword" required>
//     <Form.Label><span className="required">Mother's Name</span></Form.Label>
//     <Form.Control size='sm'
//      type="input" 
//      placeholder="Enter mother name" 
     
//      value={MotherName}
//      name = "MotherName"
//      onChange={handleInputChange}
//      required/>
//     <Form.Control.Feedback type="invalid">
//      Please mother's  name.
//    </Form.Control.Feedback>
//   </Form.Group>
//   <Form.Group  className="mb-2" required>
//     <Form.Label><span className="required">Parent's Contact Number</span></Form.Label>
//     <Form.Control size='sm'
//       type="tel"
//       maxLength="10"
//       minLength="10"
//        pattern="[0-9]*"
//         required
//         onChange={handleNumberChange}
//         value={ParentCellNumber}
//         name="ParentCellNumber"
//      />
//     <Form.Control.Feedback type="invalid">
//      Please enter Parent's Contct no.
//    </Form.Control.Feedback>
//   </Form.Group>
//   <Form.Group  className="mb-2" controlId="formBasicPassword" required>
//   <Form.Label><span className="required">Religion</span></Form.Label>
//     <Form.Control size='sm' 
//     type="input"
//      placeholder="Enter religion"
//      value={Religion}
//      name = "Religion"
//      onChange={handleInputChange}
//      required/>
//     <Form.Control.Feedback type="invalid">
//      Please enter religion.
//    </Form.Control.Feedback>
//   </Form.Group>

//   <Form.Group  className="mb-2" >
//     <Form.Label>Blood Group</Form.Label>
//     <Form.Control size='sm' 
//     type="input" 
//     placeholder="Enter blood group" 
//     value={BloodGroup}
//      name = "BloodGroup"
//      onChange={handleInputChange}
//     />
//   </Form.Group>
//   {/* </Row>
//   <Row className="mb-2"> */}
//  <Form.Group   className="mb-2" controlId="formBasicPassword" required>
//     <Form.Label><span className="required">Adhaar Number</span></Form.Label>
//     <Form.Control size='sm' 
//     type="tel"
//     maxLength="12"
//     minLength="12"
//      pattern="[0-9]*"
//       required
//       onChange={handleNumberChange}
//       value={AdhaarNumber}
//       name="AdhaarNumber"
//     />
//     <Form.Control.Feedback type="invalid">
//      Please enter adhhar no.
//    </Form.Control.Feedback>
  
//   </Form.Group>

  

//   <Form.Group  className="mb-2" required>
//     <Form.Label><span className="required">Last Qualification</span></Form.Label>
//     <Form.Control size='sm'
//      type="input"
//       placeholder="Enter last qualification"
//       value={LastQualifyName}
//       name = "LastQualifyName"
//       onChange={handleInputChange}
//       required/>
//     <Form.Control.Feedback type="invalid">
//      Please enter Last Qualification.
//    </Form.Control.Feedback>
//   </Form.Group>
 
//   <Form.Group  style = {{width:"280px"}} xs={3} className="mb-2" controlId="formBasicPassword" required>
//     <Form.Label><span className="required">Last Qualification Board</span></Form.Label>
//     <Form.Control   size='sm' 
//     type="input"
//      placeholder="Enter last qualification board" 
//      value={LastQualifyBoardName}
//       name = "LastQualifyBoardName"
//       onChange={handleInputChange}
//      required/>
//     <Form.Control.Feedback type="invalid" >
//      Please enter last qualification.
//    </Form.Control.Feedback>
//   </Form.Group>
 
//   <Form.Group  className="mb-2" controlId="formBasicPassword" required>
//     <Form.Label><span className="required">Roll number</span></Form.Label>
//     <Form.Control size='sm'
//      type="input" 
//      placeholder="Enter roll number" 
//      value={LastQualifyRollNumber}
//      name = "LastQualifyRollNumber"
//      onChange={handleInputChange}
//      required/>
//     <Form.Control.Feedback type="invalid">
//      Please enter roll number.
//    </Form.Control.Feedback>
//   </Form.Group>

//   <Form.Group  className="mb-2">
//     <Form.Label>% of Marks</Form.Label>
//     <Form.Control size='sm' 
//     type="number" 
//      className="w-50" 
//      max={100}
//      maxLength = {5}
//      value={LastQualifyMarks}
//      name = "LastQualifyMarks"
//      onChange={handleMarkChange}
//      />
//   </Form.Group>
//   <Form.Group  xs={2} className="mb-2" >
  
//   <Form.Label><span className="required">PIN Code</span></Form.Label>
//     <Form.Control  size='sm' className="w-50" 
//    type="tel"
//    maxLength="6"
//    minLength="6"
//     pattern="[0-9]*"
//      required
//      onChange={handleNumberChange}
//      value={PIN}
//      name="PIN"
//       />
//     <Form.Control.Feedback type="invalid">
//      Please enter  PIN.
//    </Form.Control.Feedback>
//   </Form.Group>
//   {/* </Row> */}
  
//   <Form.Group  xs={3} className="mb-2" controlId="formControlsTextarea">
//     <Form.Label><span className="required">Address</span></Form.Label>
//     <textarea size='sm' className="form-control rounded-0"
//      required id="exampleFormControlTextarea2" 
//      rows="3" cols = '40'
//      placeholder="Enter full address"
//      value={Address}
//      name = "Address"
//      onChange={handleInputChange}
//      ></textarea>
//     <Form.Control.Feedback type="invalid">
//      Please enter  address.
//    </Form.Control.Feedback>
//   </Form.Group>
//   {/* <Row className="mb-2"> */}
//   <Form.Group  className="mb-2" controlId="formControlsTextarea">
//     <Form.Label>Referred by</Form.Label>
//     <textarea size='sm' className="form-control rounded-0"
//      id="exampleFormControlTextarea2" 
//      rows="3" cols = '40' 
//      placeholder="Referred by whom, address and contact number"
//      value={ReferredBy}
//      name = "ReferredBy"
//      onChange={handleInputChange}
//      ></textarea>
//   </Form.Group>
//   <Form.Group  className="mb-2" controlId="formControlsTextarea">
//     <Form.Label>{id == 1 ? "School Details" : (id == 2 ? "+2 College Details" : "College Details")}</Form.Label>
//     <textarea size='sm'
//      className="form-control rounded-0" 
//      id="exampleFormControlTextarea2" 
//      rows="3" cols = '40' 
//      placeholder={id == 1 ? "Enter school details with address" : ( id == 2 ? "Enter +2 college details with address" : "Enter college details with address")}
//      value={SchoolInfo}
//      name = "SchoolInfo"
//      onChange={handleInputChange}
//      ></textarea>
//   </Form.Group>
 
 
//   <div className="form-row" style={{width:'30%'}}>
//   <div className="d-grid gap-2">
//     <p></p>
    
//   <button className="btn btn-primary" style={{background:'green'}} type="submit">
//   <span className ="spinner-border spinner-border-sm" role="status" aria-hidden="true" hidden={!isLoading}></span>
//     Register
//     </button>
  
//   <button className="btn btn-primary"style={{background:'red'}}  type="button" onClick={handleClear}>Clear</button>
// </div>
//   {/* <div class="col">
//   <Form.Group  className='Reg' controlId="formControlsTextarea">
//   <Button variant='success' class="btn btn-primary"  type="submit">
//   <span className ="spinner-border spinner-border-sm" role="status" aria-hidden="true" hidden={!isLoading}></span>
//    Register
    
//   </Button>
//   </Form.Group>
//   </div>

//   <div class="col">
//   <Form.Group className='Reg' controlId="formControlsTextarea">
  
//   <Button   variant='danger' type="submit" onClick={navigateToHome}>
//     Cancel
//   </Button>
//   </Form.Group>
//   </div> */}
  
//   </div>

  

 
//   {/* </Container>  */}
// </Form>


// <Notification
// IsSuccess = {IsSuccess}
// handleClose = {handleClose}
// Message = {message}
// msgList = {msgList}
// title = {title}

// />

// {!isHideErrorModal && <NotifyError
// isHide = {isHideErrorModal}
//  handleCloseErrorModal ={handleCloseErrorModal}
//   title = {errortitle}
//    message = {errMessage}
//     Errors ={validationError}
// />} 
//     </div>
//     </div>
//   )
// }

// Register.propTypes = {}

// export default Register;


import React, { useState,useCallback } from 'react';
import PropTypes from 'prop-types';
import MaskedFormControl from 'react-bootstrap-maskedinput';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import axios from 'axios';
import Notification from './../../Components/assets/Modals/notification';
import { REGISTER_STUDENT } from './../../url/index';
import NotifyError from './../../Components/assets/Modals/errorModal';

/* ─── Themes ─────────────────────────────────────────────────────────────────
   +2  → Forest green (3rd shade): dark green background, bright green accents
   +3  → Violet (1st shade):       deep dark purple, soft violet accents
   Pro → Black / Gold
──────────────────────────────────────────────────────────────────────────── */
const THEMES = {
  1: {
   
    cardBg: '#f4f7f6',
    pageBg: '#193D28',
    bannerBg: '#071209',
    accent: '#4ade80',
  
    hlabel: '#86efac',
    label: '#15803d',

    accentDim:   'rgba(74,222,128,0.12)',
    accentMid:   'rgba(74,222,128,0.25)',
   
    inputBg: '#ffffff',
    inputColor: '#111827',

    inputBorder: '#d1d5db',

    radioColor: '#374151',
    btn:         '#16a34a',
    btnDanger:   '#7f1d1d',
    sectionBorder: '#e5e7eb',
    tag:         '+2 Registration',
    sub:         'for +2 Arts / Science / Commerce',
  },
  2: {
  
    cardBg:      '#f4f7f6',
    pageBg:      '#0e0a1a',
    bannerBg:    '#09061a',
    accent:      '#a78bfa',
    accentDim:   'rgba(167,139,250,0.12)',
    accentMid:   'rgba(167,139,250,0.25)',
    hlabel:       '#c4b5fd',
    label:       '#0e0a1a',
    inputBg:     '#ffffff',
    inputBorder: 'rgba(167,139,250,0.2)',
    inputColor:   '#0e0a1a',
    radioColor:   '#0e0a1a',
    btn:         '#7c3aed',
    btnDanger:   '#7f1d1d',
    sectionBorder:'rgba(167,139,250,0.15)',
    tag:         '+3 Registration',
    sub:         'for +3 Arts / Science / Commerce',
  },
  3: {
    pageBg:      '#090909',
    cardBg:      '#111111',
    bannerBg:    '#0a0a0a',
    accent:      '#d4aa50',
    accentDim:   'rgba(212,170,80,0.1)',
    accentMid:   'rgba(212,170,80,0.25)',
    label:       '#fcd34d',
    hlabel: '#fcd34d',
    inputBg:     '#161616',
    inputBorder: 'rgba(212,170,80,0.2)',
    inputColor:  '#fef9ec',
    radioColor:  '#fef9ec',
    btn:         '#b45309',
    btnDanger:   '#7f1d1d',
    sectionBorder:'rgba(212,170,80,0.15)',
    tag:         'Professional Course Registration',
    sub:         'for MBA / MCA / BBA / BCA / MFC / MSW / B.LIB',
  },
};

const artsHonourseList     = [{Id:0,Name:'Select'},{Id:1,Name:'Education'},{Id:2,Name:'Odia'},{Id:3,Name:'Sociology'},{Id:4,Name:'Political Science'}];
const commerceHonourseList = [{Id:0,Name:'Select'},{Id:5,Name:'Commerce (Hons.)'}];
const scienceHonourseList  = [{Id:0,Name:'Select'},{Id:6,Name:'Physics'},{Id:7,Name:'Chemistry'},{Id:8,Name:'Mathematics'},{Id:9,Name:'Botany'},{Id:10,Name:'Zoology'},{Id:11,Name:'Geology'},{Id:12,Name:'Computer Science'}];
const prof_course_List     = [{Id:0,Name:'Select'},{Id:3,Name:'MBA'},{Id:4,Name:'MCA'},{Id:5,Name:'BBA'},{Id:6,Name:'BCA'},{Id:7,Name:'MFC'},{Id:8,Name:'MSW'},{Id:9,Name:'B.LIB'}];

/* ─── Reusable styled atoms ─────────────────────────────────────────────── */
function FieldLabel({ children, required: req, t }) {
  return (
    <label style={{ display:'block', fontSize:11, fontWeight:500, letterSpacing:'0.06em', textTransform:'uppercase', color:t.label, marginBottom:6 }}>
      {children}{req && <span style={{ color:t.accent, marginLeft:3 }}>*</span>}
    </label>
  );
}

function StyledInput({ t, error, ...props }) {
  const [focus, setFocus] = useState(false);
  return (
    <input
      {...props}
      onFocus={e => { setFocus(true); props.onFocus?.(e); }}
      onBlur={e  => { setFocus(false); props.onBlur?.(e); }}
      style={{
        width:'100%', padding:'10px 14px', borderRadius:10,
        background:t.inputBg, color:t.inputColor, fontSize:14,
        border:`1px solid ${focus ? t.accent : error ? '#f87171' : t.inputBorder}`,
        outline:'none', transition:'border-color 0.2s', boxSizing:'border-box',
        fontFamily:'inherit',
      }}
    />
  );
}

function StyledSelect({ t, error, children, ...props }) {
  const [focus, setFocus] = useState(false);
  return (
    <select
      {...props}
      onFocus={() => setFocus(true)}
      onBlur={() => setFocus(false)}
      style={{
        width:'100%', padding:'10px 14px', borderRadius:10,
        background:t.inputBg, color:t.inputColor, fontSize:14,
        border:`1px solid ${focus ? t.accent : error ? '#f87171' : t.inputBorder}`,
        outline:'none', transition:'border-color 0.2s',
        appearance:'none', cursor:'pointer', boxSizing:'border-box',
      }}
    >
      {children}
    </select>
  );
}

function StyledTextarea({ t, error, ...props }) {
  const [focus, setFocus] = useState(false);
  return (
    <textarea
      {...props}
      onFocus={() => setFocus(true)}
      onBlur={() => setFocus(false)}
      style={{
        width:'100%', padding:'10px 14px', borderRadius:10,
        background:t.inputBg, color:t.inputColor, fontSize:14,
        border:`1px solid ${focus ? t.accent : error ? '#f87171' : t.inputBorder}`,
        outline:'none', transition:'border-color 0.2s',
        resize:'vertical', minHeight:90, boxSizing:'border-box', fontFamily:'inherit',
      }}
    />
  );
}

function SectionHeading({ children, t }) {
  return (
    <div style={{
      gridColumn:'1 / -1', display:'flex', alignItems:'center', gap:10,
      padding:'12px 0 8px', borderBottom:`1px solid ${t.sectionBorder}`,
      marginTop:8, marginBottom:4,
    }}>
      <span style={{ width:3, height:16, borderRadius:2, background:t.accent, display:'inline-block', flexShrink:0 }} />
      <span style={{ fontSize:11, fontWeight:600, letterSpacing:'0.1em', textTransform:'uppercase', color:t.accent }}>
        {children}
      </span>
    </div>
  );
}

function ErrorText({ msg, t }) {
  if (!msg) return null;
  return <p style={{ color:'#f87171', fontSize:12, marginTop:4, marginBottom:0 }}>{msg}</p>;
}

function ActionButton({ t, variant='primary', loading, children, ...props }) {
  const [hov, setHov] = useState(false);
  const base = variant === 'primary' ? t.btn : t.btnDanger;
  return (
    <button
      {...props}
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      style={{
        padding:'11px 28px', borderRadius:10, border:'none',
        background: hov ? base+'cc' : base,
        color:'#fff', fontWeight:600, fontSize:14,
        cursor:'pointer', letterSpacing:'0.04em',
        transition:'background 0.18s',
        display:'flex', alignItems:'center', gap:8,
      }}
    >
      {loading && <span style={{ width:14, height:14, border:'2px solid rgba(255,255,255,0.4)', borderTopColor:'#fff', borderRadius:'50%', display:'inline-block', animation:'spin 0.7s linear infinite' }} />}
      {children}
    </button>
  );
}

/* ─── Main Component ────────────────────────────────────────────────────── */
const Register = () => {
  const { id } = useParams();
  const t = THEMES[id] || THEMES[1];

  const courseLabel = id == 1 ? '+2 Arts / Science / Commerce'
                    : id == 2 ? '+3 Arts / Science / Commerce'
                    : 'MBA / MCA / BBA / BCA / MFC / MSW / B.LIB';

  const init = {
    FirstName:'', MiddleName:'', LastName:'',
    PersonalEmail:'', PersonalCellNumber:'', ParentCellNumber:'',
    AdhaarNumber:'', PIN:'', DOB:'', dobError:'',
    Gender:'', Stream:'', Category:'', Type:'', Address:'',
    FatherName:'', MotherName:'', Religion:'', BloodGroup:'',
    LastQualifyName:'', LastQualifyBoardName:'', LastQualifyRollNumber:'', LastQualifyMarks:'',
    ReferredBy:'', SchoolInfo:'',
    IsSuccess:false, message:'', isLoading:false, title:'',
    isHideErrorModal:true, errMessage:'', validationError:null, errortitle:'',
    typeError:'', categoryError:'', streamError:'', courseError:'',
    MR_Number:'', Amount:'', Honours:'', isHonoursDisabled:true,
    honourseList:[], honoursError:'', Course:null, msgList:[],
  };

  const [eachEntry, setEachEntry] = useState(init);
  const [validated, setValidated] = useState(false);
  const set = obj => setEachEntry(p => ({ ...p, ...obj }));

  const {
    FirstName, MiddleName, LastName, PersonalEmail, PersonalCellNumber, ParentCellNumber,
    AdhaarNumber, PIN, DOB, dobError, Gender, Stream, Category, Type, Address,
    FatherName, MotherName, Religion, BloodGroup,
    LastQualifyName, LastQualifyBoardName, LastQualifyRollNumber, LastQualifyMarks,
    ReferredBy, SchoolInfo, IsSuccess, message, isLoading, title,
    isHideErrorModal, errMessage, validationError, errortitle,
    typeError, categoryError, streamError, courseError,
    MR_Number, Amount, isHonoursDisabled, Honours, honoursError, msgList,
  } = eachEntry;

  const handleInputChange  = e => set({ [e.target.name]: e.target.value });
  const handleNumberChange = e => set({ [e.target.name]: e.target.value.replace(/\D/g,'') });
  const handleKeyDown      = e => { if (e.key === ' ') e.preventDefault(); };
  const handleDateChange   = e => set({ [e.target.name]: e.target.value, dobError:'' });
  const handleRadioChange  = e => set({ [e.target.name]: e.target.id });
  const handleClear        = () => { setEachEntry(init); setValidated(false); };

  const handleDDLChange = e => {
    const { name, value, id: eid } = e.target;
    if (name === 'Stream') {
      const list = value.toLowerCase().includes('arts')     ? artsHonourseList
                 : value.toLowerCase().includes('commerce') ? commerceHonourseList
                 : value.toLowerCase().includes('science')  ? scienceHonourseList : [];
      set({ isHonoursDisabled:false, honourseList:list, [name]:value, [eid]:'',
            Honours: value.toLowerCase().includes('commerce') ? '5' : '0' });
    } else {
      set({ [name]:value, [eid]:'' });
    }
  };

  const handleCourseDDLChange = e => set({ [e.target.name]: e.target.value, [e.target.id]:'' });

  const handleMarkChange = e => {
    const num = e.target.value;
    if (num.includes('.')) {
      const parts = num.split('.');
      if (parseInt(parts[1]) < 100) set({ [e.target.name]: num });
    } else {
      if (num < 100) set({ [e.target.name]: num });
    }
  };

  const dateValidation = () => {
    const parts = DOB.split('/');
    const [day, month, year] = [parseInt(parts[0]), parseInt(parts[1]), parseInt(parts[2])];
    const cur = new Date().getFullYear();
    
    if (day > 31)                        { set({ dobError:'Enter a valid day' });   return false; }
    if (month > 12)                      { set({ dobError:'Enter a valid month' }); return false; }
    if (cur < year || (cur - year) < 12) { set({ dobError:'Enter a valid year' });  return false; }
    
    // ✅ Don't overwrite DOB — keep it as string for InputMask
    set({ dobError:'' });
    return true;
  };

  const handleSelectValidation = () => {
    const { Type:T, Stream:S, Category:C, Honours:H, Course:Co, Gender:G  } = eachEntry;
    
    if (!G || !G.length) {
      set({ validationError: null }); 
      return false;
    }
    
    if (id != 3 && (!S || !S.length))             { set({ streamError:'Select Stream' });    return false; }
    if (id == 2 && (!H || !H.length || H == '0')) { set({ honoursError:'Select Honours' });  return false; }
    if (!C || !C.length)                           { set({ categoryError:'Select Category'}); return false; }
    if (!T || !T.length)                           { set({ typeError:'Select Type' });        return false; }
    if (id == 3 && Co == null)                     { set({ courseError:'Select Course' });    return false; }
    return true;
  };

  const handleSubmit = async e => {
    e.preventDefault(); e.stopPropagation();
    if (e.currentTarget.checkValidity() && dateValidation() && handleSelectValidation()) {
      SaveStudent();
    } else { window.scrollTo(0, 0); }
    setValidated(true);
  };

  const SaveStudent = async () => {
    const parts = eachEntry.DOB.split('/');
    const dob = moment.utc(`${parts[2]}-${parts[1]}-${parts[0]}`, 'YYYY-MM-DD');
    const payload = {
      FirstName: eachEntry.FirstName, MiddleName: eachEntry.MiddleName, LastName: eachEntry.LastName,
      PersonalEmail: eachEntry.PersonalEmail, PersonalCellNumber: eachEntry.PersonalCellNumber,
      ParentCellNumber: eachEntry.ParentCellNumber, AdhaarNumber: eachEntry.AdhaarNumber,
      PIN: parseInt(eachEntry.PIN), DOB: dob, Gender: eachEntry.Gender, Stream: eachEntry.Stream,
      Category: eachEntry.Category, AccomodationType: eachEntry.Type, Address: eachEntry.Address,
      FatherName: eachEntry.FatherName, MotherName: eachEntry.MotherName, Religion: eachEntry.Religion,
      BloodGroup: eachEntry.BloodGroup, LastQualifyName: eachEntry.LastQualifyName,
      LastQualifyBoardName: eachEntry.LastQualifyBoardName, LastQualifyRollNumber: eachEntry.LastQualifyRollNumber,
      LastQualifyMarks: parseFloat(eachEntry.LastQualifyMarks), ReferredBy: eachEntry.ReferredBy,
      SchoolInfo: eachEntry.SchoolInfo, MR_Number: eachEntry.MR_Number,
      Amount: parseInt(eachEntry.Amount),
      CourseId: id == 3 ? parseInt(eachEntry.Course) : parseInt(id),
      Honours: parseInt(eachEntry.Honours),
    };
    set({ isLoading:true });
    try {
      const response = await axios.post(REGISTER_STUDENT, payload);
      if (response.status === 201) {
        const cname = id==1 ? '+2 '+payload.Stream
                    : id==2 ? '+3 '+payload.Stream
                    : (prof_course_List.find(x => x.Id == payload.CourseId) || {}).Name;
        set({
          isLoading:false, IsSuccess:true, title:'Success',
          msgList:[
            'You have successfully registered for ' + cname,
            'Your registration number is ' + response.data.Payload,
            'The final admission will take place after submitting the necessary documents and fee at Office',
          ],
        });
      } else {
        set({ isLoading:false, IsSuccess:true, title:'Error occurred!', message:'Error Occurred...!' });
      }
    // } catch (error) {
    //   debugger;
    //   if (error.response?.data) {
    //     if (error.response.status === 400) {
    //       const ve = error.response.data.Error.ValidationErrors;
    //       ve ? set({ isLoading:false, isHideErrorModal:false, errortitle:'Validation Error', errMessage:error.response.data.Error.Message, validationError:ve })
    //          : set({ isLoading:false, isHideErrorModal:false, errortitle:'Error occurred!', errMessage:error.response.data.Error.Message });
    //     } else {
    //       set({ isLoading:false, isHideErrorModal:false, errortitle:'Error occurred!', errMessage:'Please contact support.' });
    //     }
    //   } else {
    //     set({ isLoading:false, isHideErrorModal:false, errortitle:'Error occurred!', errMessage:'Please contact support.' });
    //   }
    // }
  } catch (error) {
    // Remove the two debugger statements
    
    const errData = error?.response?.data?.Error;
    
    if (errData) {
      if (error.response.status === 400) {
        const ve = errData.ValidationErrors;
        if (ve) {
          set({ 
            isLoading: false, 
            isHideErrorModal: false, 
            errortitle: 'Validation Error', 
            errMessage: errData.Message, 
            validationError: ve 
          });
        } else {
          set({ 
            isLoading: false, 
            isHideErrorModal: false, 
            errortitle: 'Error occurred!', 
            errMessage: errData.Message 
          });
        }
      } else {
        set({ 
          isLoading: false, 
          isHideErrorModal: false, 
          errortitle: 'Error occurred!', 
          errMessage: 'Please contact support.' 
        });
      }
    } else {
      set({ 
        isLoading: false, 
        isHideErrorModal: false, 
        errortitle: 'Error occurred!', 
        errMessage: error?.message || 'Please contact support.' 
      });
    }
  }
  };

  const handleClose = useCallback(() => {
     set({ IsSuccess:false, message:'', msgList:[] }); 
     window.location.reload(); 
     window.scrollTo(0,0);
     },[]);
 
     const handleCloseErrorModal = useCallback(() => {
    set({ isHideErrorModal:true, message:'', msgList:[], errMessage:'', errortitle:'', validationError:null });
  }, []);

  const maskedStyle = {
    width:'100%', padding:'10px 14px', borderRadius:10,
    background:t.inputBg, color:t.inputColor, fontSize:14,
    border:`1px solid ${dobError ? '#f87171' : t.inputBorder}`,
    outline:'none', boxSizing:'border-box', fontFamily:'inherit',
  };

  return (
    <div style={{ minHeight:'100vh', background:t.pageBg, fontFamily:"'DM Sans','Segoe UI',sans-serif", paddingBottom:'4rem' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700&family=DM+Sans:wght@300;400;500;600&display=swap');
        @keyframes spin { to { transform: rotate(360deg); } }
        input::placeholder, textarea::placeholder { color: rgba(148,163,184,0.4); }
        select option {background: #ffffff; color: #1e293b;  }
        .reg-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 18px; }
        @media(max-width:600px) { .reg-grid { grid-template-columns: 1fr; } }
        .reg-span2 { grid-column: span 2; }
        @media(max-width:600px) { .reg-span2 { grid-column: span 1; } }
        .radio-group { display: flex; flex-wrap: wrap; gap: 14px; margin-top: 4px; }
        .radio-label { display: flex; align-items: center; gap: 8px; cursor: pointer; font-size: 14px; }
        .radio-label input { width: 16px; height: 16px; cursor: pointer; accent-color: ${t.accent}; }
        .form-card { background: ${t.cardBg}; border: 1px solid ${t.accent}30; border-radius: 20px; padding: 28px; max-width: 860px; margin: 0 auto; }
        @media(max-width:700px) { .form-card { border-radius: 14px; } }
        select { appearance: none; }
      `}</style>

      {/* Banner */}
      <div style={{ background:t.bannerBg, borderBottom:`1px solid ${t.sectionBorder}`, padding:'1.8rem 1.5rem 1.5rem', position:'relative', overflow:'hidden' }}>
        <div style={{ position:'absolute', top:-50, right:-50, width:220, height:220, borderRadius:'50%', border:`1px solid ${t.accentMid}`, pointerEvents:'none' }} />
        <div style={{ position:'absolute', top:10, right:30, width:120, height:120, borderRadius:'50%', border:`1px solid ${t.sectionBorder}`, pointerEvents:'none' }} />
        <div style={{ maxWidth:860, margin:'0 auto' }}>
          <div style={{ display:'inline-flex', alignItems:'center', gap:6, background:t.accentDim, border:`1px solid ${t.accentMid}`, borderRadius:100, padding:'4px 12px', marginBottom:12 }}>
            <span style={{ width:6, height:6, borderRadius:'50%', background:t.accent, display:'inline-block' }} />
            <span style={{ fontSize:10, fontWeight:600, letterSpacing:'0.1em', textTransform:'uppercase', color:t.accent }}>{t.tag}</span>
          </div>
          <h1 style={{ fontFamily:"'Playfair Display',Georgia,serif", fontSize:'clamp(1.4rem,4vw,2.1rem)', fontWeight:700, color:'#fff', margin:'0 0 4px', lineHeight:1.1 }}>
            CTG Registration &amp; Admission
          </h1>
          <p style={{ fontSize:14, color:t.hlabel, margin:0, fontWeight:300 }}>for {courseLabel}</p>
        </div>
      </div>

      {/* Form */}
      <div style={{ maxWidth:860, margin:'2rem auto', padding:'0 1rem' }}>
        <form noValidate onSubmit={handleSubmit}>
          <div className="form-card">

            {/* Personal */}
            <div className="reg-grid">
              <SectionHeading t={t}>Personal Information</SectionHeading>

              <div><FieldLabel required t={t}>First Name</FieldLabel>
                <StyledInput t={t} type="text" placeholder="Enter first name" required name="FirstName" value={FirstName} onChange={handleInputChange} onKeyDown={handleKeyDown} />
                {validated && !FirstName && <ErrorText msg="Please enter first name" t={t} />}
              </div>

              <div><FieldLabel t={t}>Middle Name</FieldLabel>
                <StyledInput t={t} type="text" placeholder="Enter middle name" name="MiddleName" value={MiddleName} onChange={handleInputChange} onKeyDown={handleKeyDown} />
              </div>

              <div><FieldLabel required t={t}>Last Name</FieldLabel>
                <StyledInput t={t} type="text" placeholder="Enter last name" required name="LastName" value={LastName} onChange={handleInputChange} onKeyDown={handleKeyDown} />
                {validated && !LastName && <ErrorText msg="Please enter last name" t={t} />}
              </div>

              <div><FieldLabel required t={t}>Date of Birth</FieldLabel>
                <MaskedFormControl type="text" mask="11/11/1111" required onChange={handleDateChange} value={DOB} name="DOB" style={maskedStyle} />
                {(dobError || (validated && !DOB)) && <ErrorText msg={dobError || 'Please enter DOB'} t={t} />}
              </div>

              <div><FieldLabel required t={t}>Gender</FieldLabel>
                <div className="radio-group">
                  {['Male','Female','Other'].map(g => (
                    <label key={g} className="radio-label" style={{ color:t.radioColor }}>
                      <input type="radio" name="Gender" id={g} checked={Gender===g} onChange={handleRadioChange} />
                      {g}
                    </label>
                  ))}
                </div>
                {validated && !Gender && <ErrorText msg="Please select gender" t={t} />}
              </div>

              <div><FieldLabel t={t}>Blood Group</FieldLabel>
                <StyledInput t={t} type="text" placeholder="e.g. O+" name="BloodGroup" value={BloodGroup} onChange={handleInputChange} />
              </div>

              <div><FieldLabel required t={t}>Religion</FieldLabel>
                <StyledInput t={t} type="text" placeholder="Enter religion" required name="Religion" value={Religion} onChange={handleInputChange} />
                {validated && !Religion && <ErrorText msg="Please enter religion" t={t} />}
              </div>

              <div><FieldLabel required t={t}>Aadhaar Number</FieldLabel>
                <StyledInput t={t} type="tel" placeholder="12-digit Aadhaar" maxLength={12} minLength={12} required name="AdhaarNumber" value={AdhaarNumber} onChange={handleNumberChange} />
                {validated && AdhaarNumber.length < 12 && <ErrorText msg="Enter valid Aadhaar number" t={t} />}
              </div>
            </div>

            {/* Contact */}
            <div className="reg-grid" style={{ marginTop:8 }}>
              <SectionHeading t={t}>Contact Details</SectionHeading>

              <div><FieldLabel required t={t}>Contact Number</FieldLabel>
                <StyledInput t={t} type="tel" maxLength={10} minLength={10} required name="PersonalCellNumber" value={PersonalCellNumber} onChange={handleNumberChange} placeholder="10-digit mobile" />
                {validated && PersonalCellNumber.length < 10 && <ErrorText msg="Enter valid contact number" t={t} />}
              </div>

              <div><FieldLabel t={t}>Email Address</FieldLabel>
                <StyledInput t={t} type="email" placeholder="example@mail.com" name="PersonalEmail" value={PersonalEmail} onChange={handleInputChange} />
              </div>

              <div><FieldLabel required t={t}>PIN Code</FieldLabel>
                <StyledInput t={t} type="tel" maxLength={6} minLength={6} required name="PIN" value={PIN} onChange={handleNumberChange} placeholder="6-digit PIN" />
                {validated && PIN.length < 6 && <ErrorText msg="Enter valid PIN code" t={t} />}
              </div>

              <div className="reg-span2"><FieldLabel required t={t}>Address</FieldLabel>
                <StyledTextarea t={t} placeholder="Enter full address" required name="Address" value={Address} onChange={handleInputChange} rows={3} />
                {validated && !Address && <ErrorText msg="Please enter address" t={t} />}
              </div>
            </div>

            {/* Family */}
            <div className="reg-grid" style={{ marginTop:8 }}>
              <SectionHeading t={t}>Family Details</SectionHeading>

              <div><FieldLabel required t={t}>Father's Name</FieldLabel>
                <StyledInput t={t} type="text" placeholder="Enter father's name" required name="FatherName" value={FatherName} onChange={handleInputChange} />
                {validated && !FatherName && <ErrorText msg="Please enter father's name" t={t} />}
              </div>

              <div><FieldLabel required t={t}>Mother's Name</FieldLabel>
                <StyledInput t={t} type="text" placeholder="Enter mother's name" required name="MotherName" value={MotherName} onChange={handleInputChange} />
                {validated && !MotherName && <ErrorText msg="Please enter mother's name" t={t} />}
              </div>

              <div><FieldLabel required t={t}>Parent's Contact Number</FieldLabel>
                <StyledInput t={t} type="tel" maxLength={10} minLength={10} required name="ParentCellNumber" value={ParentCellNumber} onChange={handleNumberChange} placeholder="10-digit mobile" />
                {validated && ParentCellNumber.length < 10 && <ErrorText msg="Enter valid contact number" t={t} />}
              </div>
            </div>

            {/* Academic */}
            <div className="reg-grid" style={{ marginTop:8 }}>
              <SectionHeading t={t}>Academic Details</SectionHeading>

              {id == 3
                ? <div><FieldLabel required t={t}>Select Course</FieldLabel>
                    <StyledSelect t={t} error={courseError} name="Course" id="courseError" defaultValue="0" onChange={handleCourseDDLChange}>
                      {prof_course_List.map((x,y) => <option key={y} value={x.Id}>{x.Name}</option>)}
                    </StyledSelect>
                    <ErrorText msg={courseError} t={t} />
                  </div>
                : <div><FieldLabel required t={t}>Select Stream</FieldLabel>
                    <StyledSelect t={t} error={streamError} name="Stream" id="streamError" defaultValue="DEFAULT" onChange={handleDDLChange}>
                      <option value="DEFAULT" disabled>Select</option>
                      <option value="Arts">Arts</option>
                      <option value="Science">Science</option>
                      <option value="Commerce">Commerce</option>
                    </StyledSelect>
                    <ErrorText msg={streamError} t={t} />
                  </div>
              }

              {id == 2 &&
                <div><FieldLabel required t={t}>Select Honours</FieldLabel>
                  <StyledSelect t={t} error={honoursError} name="Honours" id="honoursError" value={Honours} onChange={handleDDLChange} disabled={isHonoursDisabled}>
                    {eachEntry.honourseList.map((x,y) => <option key={y} value={x.Id}>{x.Name}</option>)}
                  </StyledSelect>
                  <ErrorText msg={honoursError} t={t} />
                </div>
              }

              <div><FieldLabel required t={t}>Select Category</FieldLabel>
                <StyledSelect t={t} error={categoryError} name="Category" id="categoryError" defaultValue="DEFAULT" onChange={handleDDLChange}>
                  <option value="DEFAULT" disabled>Select</option>
                  {['ST','SC','OBC','SEBC','General'].map(c => <option key={c} value={c}>{c}</option>)}
                </StyledSelect>
                <ErrorText msg={categoryError} t={t} />
              </div>

              <div><FieldLabel required t={t}>Accommodation Type</FieldLabel>
                <StyledSelect t={t} error={typeError} name="Type" id="typeError" defaultValue="DEFAULT" onChange={handleDDLChange}>
                  <option value="DEFAULT" disabled>Select</option>
                  <option value="Day Boarding">Day Boarding</option>
                  <option value="Day Scholar">Day Scholar</option>
                  <option value="Residential">Residential</option>
                </StyledSelect>
                <ErrorText msg={typeError} t={t} />
              </div>

              <div><FieldLabel required t={t}>Last Qualification</FieldLabel>
                <StyledInput t={t} type="text" placeholder="e.g. Matriculation" required name="LastQualifyName" value={LastQualifyName} onChange={handleInputChange} />
                {validated && !LastQualifyName && <ErrorText msg="Please enter last qualification" t={t} />}
              </div>

              <div><FieldLabel required t={t}>Board / University</FieldLabel>
                <StyledInput t={t} type="text" placeholder="e.g. BSE Odisha" required name="LastQualifyBoardName" value={LastQualifyBoardName} onChange={handleInputChange} />
                {validated && !LastQualifyBoardName && <ErrorText msg="Please enter board name" t={t} />}
              </div>

              <div><FieldLabel required t={t}>Roll Number</FieldLabel>
                <StyledInput t={t} type="text" placeholder="Enter roll number" required name="LastQualifyRollNumber" value={LastQualifyRollNumber} onChange={handleInputChange} />
                {validated && !LastQualifyRollNumber && <ErrorText msg="Please enter roll number" t={t} />}
              </div>

              <div><FieldLabel t={t}>% of Marks</FieldLabel>
                <StyledInput t={t} type="number" placeholder="e.g. 75.5" max={100} name="LastQualifyMarks" value={LastQualifyMarks} onChange={handleMarkChange} />
              </div>

              <div className="reg-span2"><FieldLabel t={t}>{id==1 ? 'School Details' : id==2 ? '+2 College Details' : 'College Details'}</FieldLabel>
                <StyledTextarea t={t} placeholder={id==1 ? 'Enter school name and address' : 'Enter college name and address'} name="SchoolInfo" value={SchoolInfo} onChange={handleInputChange} rows={2} />
              </div>
            </div>

            {/* Payment */}
            <div className="reg-grid" style={{ marginTop:8 }}>
              <SectionHeading t={t}>Payment &amp; Reference</SectionHeading>

              <div><FieldLabel t={t}>MR Number</FieldLabel>
                <StyledInput t={t} type="text" placeholder="Money receipt number" name="MR_Number" value={MR_Number} onChange={handleInputChange} />
              </div>

              <div><FieldLabel t={t}>Amount Paid (₹)</FieldLabel>
                <StyledInput t={t} type="tel" maxLength={5} placeholder="e.g. 5000" name="Amount" value={Amount} onChange={handleNumberChange} />
              </div>

              <div className="reg-span2"><FieldLabel t={t}>Referred By</FieldLabel>
                <StyledTextarea t={t} placeholder="Name, address and contact of referrer" name="ReferredBy" value={ReferredBy} onChange={handleInputChange} rows={2} />
              </div>
            </div>

            {/* Actions */}
            <div style={{ display:'flex', gap:12, marginTop:28, flexWrap:'wrap' }}>
              <ActionButton t={t} type="submit" variant="primary" loading={isLoading}>
                {isLoading ? 'Submitting...' : 'Register'}
              </ActionButton>
              <ActionButton t={t} type="button" variant="danger" onClick={handleClear}>
                Clear Form
              </ActionButton>
            </div>

          </div>
        </form>
      </div>

       {/* <Notification IsSuccess={IsSuccess} handleClose={handleClose} Message={message} msgList={msgList} title={title} />
      {!isHideErrorModal && (
        <NotifyError isHide={isHideErrorModal}
         handleCloseErrorModal={handleCloseErrorModal} 
         title={errortitle} message={errMessage} Errors={validationError} />
      )}  */}

 <Notification
  IsSuccess={IsSuccess}
  handleClose={handleClose}
  msgList={msgList}
  title={title}
  themeId={id}   
  Message={message}      
/>

{!isHideErrorModal && (
  <NotifyError
    isHide={isHideErrorModal}
    handleCloseErrorModal={handleCloseErrorModal}
    title={errortitle}
    message={errMessage}
    Errors={validationError}
    themeId={id}        
  />
)} 
    </div>
  );
};

Register.propTypes = {};
export default Register;